import cheer from '../../assets/mascot-cheer.svg';
import think from '../../assets/mascot-think.svg';
import wave from '../../assets/mascot-wave.svg';
import idle from '../../assets/mascot.svg';

export type MascotPose = 'idle' | 'wave' | 'think' | 'cheer';

const SRC: Record<MascotPose, string> = { idle, wave, think, cheer };

/** Decorative brand mascot (200x220 in Figma). Pass `className` to size it. */
export function Mascot({ pose = 'idle', className }: { pose?: MascotPose; className?: string }) {
  return <img src={SRC[pose]} alt="" aria-hidden className={className} />;
}
